// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/analytics_dashboard/:app_group_id/email_credit_consumption_detail_data" endpoint
 */
import { isEmailConsumptionResult } from "@dashboardApi/apis/emailConsumption/validators";

import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { emailConsumption } from "./constants";
import type { EmailConsumptionParams, EmailConsumptionResult } from "./types";

export const getDataTableEmailConsumption = reactQueryTableFetcherAdapter(
  emailConsumption,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 20, start = 0, sortdir, sortby }: EmailConsumptionParams
  ): Promise<EmailConsumptionResult> => {
    const { start_date, end_date, app_group: appGroup } = query;

    return fetch(
      `/analytics_dashboard/${appGroupId}/email_credit_consumption_detail_data`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        start_date: start_date,
        end_date: end_date,
        query: serializeQueryObjects({
          ...(appGroup && { app_group: appGroup }),
        }),
      },
      { signal }
    );
  },
  isEmailConsumptionResult
);
